import React, { FC, ReactElement } from 'react'
import styles from './Modal.module.css'

import MuiModal from '@mui/material/Modal'
import classNames from 'classnames'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

// use modal v2
const Modal: FC<{
	open: boolean
	onClose: (evt: any) => void
	children?: React.ReactNode
	className?: string
	bodyClassName?: string
	containerClassName?: string
	// A form dialog must not be a button. iOS will not focus a text field, or
	// show the keyboard, when the field sits inside role="button".
	dialogLabel?: string
	dialogLabelledBy?: string
	disableAutoFocus?: boolean
	/** Stack above other layers (offer dialogs sit at 1300); the wallet unlock uses this. */
	zIndex?: number
}> = (props): ReactElement => {
	const { className, bodyClassName } = props
	const dialog = !!props.dialogLabel
	return (
		<MuiModal
			open={props.open}
			onClose={props.onClose}
			className={styles.layer}
			style={{ pointerEvents: 'auto', ...(props.zIndex ? { zIndex: props.zIndex } : {}) }}
			disableAutoFocus={props.disableAutoFocus}
			slotProps={{ backdrop: { classes: { root: styles.backdrop } } }}
		>
			<div
				className={classNames(
					{ [props.className as any]: !!className },
					styles.root,
					dialog && styles.dialogRoot
				)}
				onClick={props.onClose}
				role={dialog ? 'presentation' : 'button'}
				tabIndex={dialog ? undefined : 0}
				onKeyDown={dialog ? undefined : onKeyboardClick(props.onClose)}
			>
				<div
					className={classNames(
						{ [props?.containerClassName as any]: !!props?.containerClassName },
						styles.container
					)}
				>
					<div
						onClick={(evt) => {
							evt.stopPropagation()
						}}
						className={classNames({ [props.bodyClassName as any]: !!bodyClassName }, styles.body)}
						role={dialog ? 'dialog' : 'button'}
						aria-modal={dialog ? true : undefined}
						aria-label={dialog && !props.dialogLabelledBy ? props.dialogLabel : undefined}
						aria-labelledby={dialog ? props.dialogLabelledBy : undefined}
						tabIndex={dialog ? -1 : 0}
						onKeyDown={
							dialog
								? undefined
								: onKeyboardClick((evt) => {
										evt.stopPropagation()
								  })
						}
					>
						{props.children}
					</div>
				</div>
			</div>
		</MuiModal>
	)
}

export default Modal
